// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2lISD","left":"StickyBox_left__2agtm","right":"StickyBox_right__26qQw"};